import { useQuery } from '@tanstack/react-query';

import type { operations } from '@luxuryescapes/contract-svc-promo';

import { getAdminUserMyVouchers } from '~/services/PromoService';

type MyVouchersQuery = operations['listAdminUserMyVouchers']['parameters']['query'];

export const myVouchersQueryKeys = {
  all: ['my-vouchers'] as const,
  account: (brand: string, userId: string, region: string, locale: string, status: MyVouchersQuery['status']) =>
    [...myVouchersQueryKeys.all, 'account', brand, userId, region, locale, status] as const,
};

type Params = {
  brand: string;
  userId: string;
  region: string;
  locale: string;
  status: MyVouchersQuery['status'];
};

/**
 * Prepares the account-facing voucher presentation for an explicitly selected user.
 * Call `refetch` to load it; this preview must not fetch when the selected user changes.
 */
export function useGetMyVouchers({ brand, userId, region, locale, status }: Params) {
  const normalizedUserId = userId.trim();

  return useQuery({
    queryKey: myVouchersQueryKeys.account(brand, normalizedUserId, region, locale, status),
    queryFn: async ({ signal }) =>
      getAdminUserMyVouchers(
        normalizedUserId,
        {
          brand,
          limit: 100,
          location: 'account',
          page: 1,
          region,
          status,
        },
        { signal, locale },
      ),
    enabled: false,
  });
}
